<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="getAnotacoes()"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(info)="row">
                <div v-if="Number.isInteger(row.item.id)">
                    <rkm-icon
                        :id="`pronto-atendimento-anotacao-enfermagem-info-${row.item.id}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`pronto-atendimento-anotacao-enfermagem-info-${row.item.id}`"
                        triggers="hover"
                    >
                        <div>{{ row.item.centroCusto.setor.nome }}</div>
                        <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div><rkm-icon :icon="['far', 'clock']" /> {{ row.item.dataHora }}</div>
                        <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                    </rkm-popover>
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="handleDestroy(row.index)"
                    color="danger"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    data: () => ({
        fields: [
            { key: 'info', label: '#', class: 'col-min' },
            { key: 'dataHoraAnotacao', label: 'Data / Hora informada', class: 'col-min' },
            { key: 'anotacao', label: 'Anotações' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        handleDestroy(index) {

            const destroy = async () => this.data.model.anotacoes.splice(index, 1)

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
        getAnotacoes() {

            const anotacoes1 = Object.values(this.data.form.atendimentoEnfermagem.anotacoes || []);
            const anotacoes2 = Object.values(this.data.model.anotacoes || []);

            return anotacoes1.concat(anotacoes2);
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>